module.exports = __webpack_public_path__ + "img/img27.bb242b58.png";